import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import DashboardLayout from './components/layouts/DashboardLayout';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();

  // Verify auth status on each route change
  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </DashboardLayout>
    );
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Force logout if role doesn't match
    window.location.href = '/';
    return null;
  }

  return children;
};

export default ProtectedRoute;